import { FetchMyFavType } from '../redux/lounges/slice';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { readLoungeAuthorizedData } from '../utils/loungeAuthRefresh';

export const getAllMyMWApi = async ({
  sortType: _sortType,
  currentPage: _currentPage,
  UserId: _userId,
}: FetchMyFavType) => {
  return readLoungeAuthorizedData(
    GET_BASE_URL + '/api/v1/myfavourites',
    'myfavourites'
  );
};
